import { Component, OnInit } from '@angular/core';
import { roles } from 'src/app/Enums/roles';

@Component({
  selector: 'app-shop-layout',
  templateUrl: './shop-layout.component.html',
  styleUrls: ['./shop-layout.component.css']
})
export class ShopLayoutComponent implements OnInit {
  roleToAcess: boolean = false;
  constructor() { }

  ngOnInit() {
    this.roleToAcess = roles[localStorage.getItem('role')] == 'Admin' ? true : false;
  }

}
